export const KINESCOPE_STORAGE_KEY = 'ks';
export const KINESCOPE_SAVE_INTERVAL_MS = 3000;
export const VIDEO_TIMINGS_INTERVAL = 10000;
